import '../../../../fe-global/src/assets/js/app-app-ux-manual'